export {
  FavouriteButton,
  /** @deprecated - use named export instead */
  FavouriteButton as default
} from "../../buttons/FavouriteButton";
